import request from "@/utils/request";
import Qs from "qs";
// 公共接口

// 获取房源类型
export function housing_type(data) {
  return request({
    url: "/common/house_types",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 获取系统配置
export function get_system_conf(data) {
  return request({
    url: "/common/get_system_conf",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 优惠券模板列表
export function get_carport_coupon_tpl_lists(data) {
  return request({
    url: "/common/get_carport_coupon_tpl_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}